import { createSelector } from "reselect";

export function createHealingIndexQueryForSeriesIdSelector({ seriesId }) {
  return createSelector(() => {
    return `?filter[series_id]=${seriesId}`;
  });
}
